import React from "react";
import { Link } from "react-router-dom";
import InArticleAd from "../../Ads/inArticleAd";
import BannerAd from "../../Ads/bannerAd";
import { formatDate } from "../../../utils/dateFormate";

const PostDetails = ({ post }) => {
  if (!post) {
    return <div>Post not found!</div>;
  }

  // 1. Safely parse stringified JSON fields
  const imageObj =
    typeof post.image === "string" ? JSON.parse(post.image) : post.image;
  const authorObj =
    typeof post.author === "string" ? JSON.parse(post.author) : post.author;

  // 2. Safely calculate the image source
  const imgSrc = imageObj?.src
    ? imageObj.src.startsWith("http")
      ? imageObj.src
      : `/${imageObj.src}`
    : "/assets/images/default-placeholder.jpg";

  return (
    <>
      {post ? (
        <div className="post-details">
          <div className="post-details__author">
            <img
              width={100}
              height={100}
              loading="lazy"
              src={imgSrc}
              alt={post.image?.alt || "Blog post image"}
              title={post.image?.alt || "Blog post"}
            />
            <h2>{post.author.name}</h2>
          </div>
          <div className="post-details__image">
            <img
              loading="lazy"
              width={100}
              height={100}
              src={imgSrc}
              alt={post.image?.alt || "Blog post image"}
              title={post.image?.alt || "Blog post"}
            />
          </div>
          <div className="post-details__content">
            <h1 className="post-details__title">{post.title}</h1>
            <h3 className="post-details__category">
              {post.category.toUpperCase()}
            </h3>
            <p className="post-details__date">{formatDate(post.date)}</p>
            <p
              className="post-details__description"
              dangerouslySetInnerHTML={{ __html: post.description }}
            />
            <InArticleAd />
            <p
              className="post-details__summary"
              dangerouslySetInnerHTML={{ __html: post.summary }}
            />
            <p className="post-details__tags">
              {post.tags?.split(",").length > 0 &&
                post.tags?.split(",").map((tag, index) => (
                  <button key={index} className="post-details__tags-button">
                    {tag.trim()}
                  </button>
                ))}
            </p>
          </div>
          <div className="post-details__footer">
            <Link
              className="post-details__footer--btn"
              to={post.blogDetailLink}
            >
              Read More on Seed To Tree Academy Blog
            </Link>
          </div>
          <BannerAd />
          {/* <div className="post-details__footer">
            <ShareButton
              title={post.title}
              url={`"https://seedtotree.netlify.app/blog/${post.slug}";`}
            />
          </div> */}
        </div>
      ) : null}
    </>
  );
};

export default PostDetails;
